import { Injectable } from '@angular/core';
import {
  FinancialRow,
  IssueCard,
  TaxAccountingResponseDto,
} from '../interface/taxAccounting.interface';
import { AppCommonService } from './app-common.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaxAccountingService {

  tbbsStatus = new BehaviorSubject<string[]>([]);
  fetchTaxAccountingList = new BehaviorSubject<boolean>(false);

  constructor(private readonly commonService: AppCommonService) {}

  bindTaxAccounting(list: TaxAccountingResponseDto[]): IssueCard[] {
    let filteredResult: IssueCard[] = [];
    list.forEach((l: TaxAccountingResponseDto) => {
      let financialRow: FinancialRow[] = [
        {
          label: 'TI b/f 199',
          year: l.issueYear,
          us: l.tI_bf199_US,
          passive: l.tI_bf199_Passive,
          capitalGain: l.tI_bf199_Capital_Gain,
          general: l.tI_bf199_General,
          fogei: l.tI_bf199_FOGEI,
          fori: l.tI_bf199_FORI,
          brNogi: l.tI_bf199_BR_NOGI,
          brCfogi: l.tI_bf199_BR_CFOGI,
          nbrNogi: l.tI_bf199_NBr_NOGI,
          nbrCfogi: l.tI_bf199_NBr_CFOGI,
          giltiNogi: l.tI_bf199_GILTI_NOGI,
          giltiFori: l.tI_bf199_GILTI_FORI,
        },
        {
          label: '199 Deduct',
          us: l.deduct199_US,
          passive: l.deduct199_Passive,
          general: l.deduct199_General,
          fogei: l.deduct199_FOGEI,
          fori: l.deduct199_FORI,
        },
        {
          label: l.net_T1,
          us: l.net_T1_35_US,
          passive: l.net_T1_35_Passive,
          capitalGain: l.net_T1_35_Capital_Gain,
          general: l.net_T1_35_General,
          fogei: l.net_T1_35_FOGEI,
          fori: l.net_T1_35_FORI,
          brNogi: l.net_T1_35_BR_NOGI,
          brCfogi: l.net_T1_35_BR_CFOGI,
          nbrNogi: l.net_T1_35_NBr_NOGI,
          nbrCfogi: l.net_T1_35_NBr_CFOGI,
          giltiNogi: l.net_T1_35_GILTI_NOGI,
          giltiFori: l.net_T1_35_GILTI_FORI,
        },
        {
          label: 'FTC',
          passive: l.ftC_Passive,
          general: l.ftC_General,
          fogei: l.ftC_FOGEI,
          fori: l.ftC_FORI,
          brNogi: l.ftC_BR_NOGI,
          brCfogi: l.ftC_BR_CFOGI,
          nbrNogi: l.ftC_NBr_NOGI,
          nbrCfogi: l.ftC_NBr_CFOGI,
          giltiNogi: l.ftC_GILTI_NOGI,
          giltiFori: l.ftC_GILTI_FORI,
        },
        {
          label: 'GBC',
          us: l.gbc,
        },
        {
          label: 'Issue',
          issueText: l.desc || '',
          asC_740_comment: l.asC_740_comment || '',
        },
      ];

      let issue: IssueCard = {
        id: l.id,
        issueNo: l.issueID,
        entityCode: l.entityCode,
        contact: l.contact,
        approver: l.approver,
        createdOn: this.commonService.formatDisplayDate(l.dateCreation),
        modifiedOn: this.commonService.formatDisplayDate(l.dateModification),
        asC_740Flag: l.asC_740Flag,
        asC_740_IssueID: l.asC_740_IssueID,
        tbbsFlag: l.tbbsFlag,
        tbbsStatus: l.tbbsStatus,
        tbbsDescription: l.tbbs,
        arFilingId: l.amendedID,
        arIssueId: l.arIssueID,
        irsIssueId: l.irsIssueID,
        saaNo: l.saA_ID,
        submission: l.saA_Submission,
        spLink: l.sP_DocID,
        npa: l.npa,
        issueStatus: l.issue_Status,
        details: financialRow,
      };

      filteredResult.push(issue);
    });
    return filteredResult;
  }

  setTBBSStatus(status: string[]): void {
    this.tbbsStatus.next(status);
  }

  triggerFetchTaxAccountingList(flag: boolean): void {
    this.fetchTaxAccountingList.next(flag);
  }

}
